import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { shadows } from "../../../design-system/tokens/shadows";
import {
  Card as StoryCreationCard,
  IllustrationArea as StoryCreationIllustrationArea,
  Label as StoryCreationLabel,
} from "../AiStoryCreationCard/AiStoryCreationCard.styles";

export const Card = styled(StoryCreationCard)`
  background: ${({ theme }) =>
    theme.colors?.background?.primary ?? rawColors.structural.white};
  box-shadow: ${shadows.component.card.storyCreationBlank};
`;

export const Label = styled(StoryCreationLabel)`
  width: 100%;
`;

export const IllustrationArea = styled(StoryCreationIllustrationArea)``;

export const PreviewImage = styled.img`
  display: block;
  width: 5.0625rem;
  height: 3.25rem;
  flex-shrink: 0;
`;
